import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PerkTemplate } from 'components/perks/templates/models/PerkTemplate';
import { perkTemplateApi } from 'components/perks/templates/PerkTemplateApi';
import logger from 'lib/logger';
import type { AppDispatch } from '../store';

export interface PerkTemplatesState {
    templates: PerkTemplate[];
    loading: boolean;
}

export const initialState: PerkTemplatesState = {
    templates: [],
    loading: false
};

const perkTemplatesSlice = createSlice({
    name: 'perkTemplates',
    initialState,
    reducers: {
        startRequest(state) {
            state.loading = true;
        },
        loadSuccess(state, action: PayloadAction<PerkTemplate[]>) {
            state.loading = false;
            state.templates = action.payload;
        },
        loadError(state) {
            state.loading = false;
            state.templates = [];
        },
        createSuccess(state, action: PayloadAction<PerkTemplate>) {
            state.templates = [...state.templates, action.payload];
        },
        updateSuccess(state, action: PayloadAction<PerkTemplate>) {
            state.templates = state.templates.map(t => (t._id === action.payload._id ? action.payload : t));
        },
        deleteSuccess(state, action: PayloadAction<string>) {
            state.templates = state.templates.filter(t => t._id !== action.payload);
        }
    }
});

export const { startRequest, loadSuccess, loadError, createSuccess, updateSuccess, deleteSuccess } =
    perkTemplatesSlice.actions;

export function loadAllTemplates() {
    return async function (dispatch: AppDispatch) {
        dispatch(startRequest());
        try {
            const response = await perkTemplateApi.getList();
            if (!response.ok) {
                throw new Error(`Failed to load templates with code: ${response.statusCode}`);
            }
            dispatch(loadSuccess(response.body?.items ?? []));
        } catch (e) {
            logger.error('Failed to load perk templates', e);
            dispatch(loadError());
        }
    };
}

export default perkTemplatesSlice.reducer;
